import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Navbar, Footer, MyProfileCertificate } from '../../Component';
import { LanguageProvider } from '../../store';
import styles from "./MyCertificate.module.css";

function MyCertificate() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div>
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}
      <LanguageProvider>
        <Navbar />
        <MyProfileCertificate />
        <Footer />
      </LanguageProvider>
    </div>
  );
}

export default MyCertificate;